"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putOrderNumbersCsv = void 0;
/**
 * Get a presigned S3 url for uploading a third party order number CSV
 */
var putOrderNumbersCsv = function (instance) { return function (body, config) {
    return instance.put("/catalogues/order-numbers", body, config);
}; };
exports.putOrderNumbersCsv = putOrderNumbersCsv;
